import moment from "moment";
import { LOCALISATION_KEY_PAYMENT_METHOD_CARD_LABEL, PAYMENT_METHOD_CARD_LABEL_STATIC } from "./data";
import { FARE_PLATFORM_FEE_PERCENT, FARE_GST_PERCENT } from "./common.data";

export const adminEditStatus = ['accept', 'begin', 'expired', 'cancelled','cancel', 'completed','paid_cancel','p_cancel_drop']


export const statusValues = {
  request: "Request",
  confirm: "Confirmed",
  confirmed: "Confirmed",
  assigned: "Partner Assigned",
  accept: "Partner Accepted",
  arrive: "Partner Arrived",
  begin: "Begin",
  completed: "Completed",
  cancel: "Cancelled",
  p_cancel_pickup: "Partner Cancel at Pickup Location",
  p_cancel_drop: "Partner Cancel at Drop Location",
  expired: "Expired",
  paid_cancel: "Cancelled",
}

export const statusValuesColor = {
  request: "darkred",
  confirm: "green",
  confirmed: "green",
  assigned: "darkred",
  accept: "darkred",
  arrive: "darkred",
  begin: "darkred",
  completed: "green",
  cancel: "darkred",
  p_cancel_pickup: "darkred",
  p_cancel_drop: "darkred",
  expired: "darkred",
  paid_cancel: "darkred",
}

export const getDateDifference = (start, end) => {
  const startDate = moment(start);
  const endDate = moment(end);

  // Difference in milliseconds
  const diffMs = endDate.diff(startDate);

  // Convert to hours (including partial hours)
  const diffHours = diffMs / (1000 * 60 * 60);

  return diffHours;
}

export const isInvalidValue = (value) => {
  return value ? value : ""
}

export const extractSuggestionProps = (getSuggestionItemProps) => {
  const { key, ...restProps } = getSuggestionItemProps; // Destructure and remove key
  return restProps;
};

export const getMinDateTime = (date) => {
  return moment(date).startOf('date').format("YYYY-MM-DDTHH:mm");
};

export const getEstimatedFare = function (cat_id, Est_Fare_List) {
  const fare = Est_Fare_List[cat_id]?.trip_pay_amount;
  return fare;
};

export const getTripPercentageAmount = (totalPrice, percentage) => {
  return (totalPrice * percentage) / 100;
};
export const getSeatCategory = (maxSeat,groupDetail) => {
  return groupDetail?.data.flatMap((row) => 
    row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  );
  // // Condition for available buses or cabs based on maxSeat
  // if (maxSeat === 2) return [1,2]; // e.g., Small car or compact bus
  // if (maxSeat === 3) return [1,2,3]; // e.g., Small car or compact bus
  // if (maxSeat === 4) return [1,2,3,4]; // e.g., Small car or compact bus
  // // if (maxSeat === 5) return [1, 2, 3, 5]; // e.g., SUV or mini-bus

  // if (maxSeat === 5) {
  //   // if (groupDetail?.data[0]?.length === 3) {
  //   //   return [1,3,4,5] // 2 row
  //   // } else if (groupDetail?.data[1]?.length === 3) {
  //   //   return [1,2,3,5] // 2 row
  //   // } else if ( groupDetail?.data[0]?.length === 1) {
  //   //   return [1,2,3] // 3 row
  //   // }  else {
  //   //   return [1,2,3,4,5]
  //   // } 
  //   return groupDetail?.data.flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
  // }; // e.g., SUV or mini-bus

  // if (maxSeat === 6) {
  //   if (groupDetail?.data[0]?.length === 2 && groupDetail?.data[1]?.length === 2) {
  //     return [1,2,3,4] // 2 row
  //   } else if (groupDetail?.data[0]?.length === 3 && groupDetail?.data[1]?.length === 3) {
  //     return groupDetail?.data.flatMap((row) => 
  //       row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //     );
  //   } else
  //    {
  //     return [1,2,3,4,5,6] // 2 row
  //   } 
  // }; // e.g., SUV or mini-bus

  // if (maxSeat === 7) {
  //   // if (groupDetail?.data[1]?.length === 3) {
  //   //   return [1,2,3,4,5]
  //   // } else if (groupDetail?.data[2]?.length === 3) {
  //   //   // return [5,6,7]
  //   //      return [1,2,3,4]
  //   // } else if (groupDetail?.data[0]?.length === 3) {
  //   //   // return [2,6,7]
  //   //   return [1,3,4,5]
  //   // } else
  //   //  {
  //   //   return [0]
  //   // } 

  //   return groupDetail?.data.slice(0, -1) // Excludes only the last row (corrected)
  //   .flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
    
  // }; // e.g., Mid-size van or larger bus


  // if (maxSeat === 8) {
  //   // if (groupDetail?.data[0]?.length === 2 && groupDetail?.data[1]?.length === 2 && groupDetail?.data[2]?.length === 2) {
  //   //   // return [7, 8]
  //   //   return [1,2,3,4,5,6]
  //   // } else if (groupDetail?.data[0]?.length === 2 && groupDetail?.data[1]?.length === 3 && groupDetail?.data[2]?.length === 3) {
  //   //   // return [4,6,7,8]
  //   //         return [1,2,3,5]
  //   // } else if (groupDetail?.data[0]?.length === 3 && groupDetail?.data[1]?.length === 3 && groupDetail?.data[2]?.length === 2) {
  //   //   // return [2,5,7,8]
  //   //   return [1,3,4,6]
  //   // } else
  //   //  {
  //   //   return [0]
  //   // } 
  //   return groupDetail?.data.slice(0, -1) // Excludes only the last row (corrected)
  //   .flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
  // }; // e.g., Standard bus or minivan

  // if (maxSeat === 9) {
  //   if (
  //     groupDetail?.data?.[0]?.length === 1 &&
  //     groupDetail?.data?.[1]?.length === 2 &&
  //     groupDetail?.data?.[2]?.length === 2
  //   ) {
  //     return [1, 2, 3, 4, 5, 6, 7];
  //   } else if (
  //     groupDetail?.data?.[0]?.length === 3 &&
  //     groupDetail?.data?.[1]?.length === 3 &&
  //     groupDetail?.data?.[2]?.length === 3
  //   ) {
  //     return [1, 3, 4, 6];
  //   } else if (
  //     groupDetail?.data?.length === 3 &&
  //     groupDetail?.data?.[0]?.length === 2 &&
  //     groupDetail?.data?.[1]?.length === 4
  //   ) {
  //     return [1, 2, 3, 6];
  //   } else if (
  //     groupDetail?.data?.length === 3 &&
  //     groupDetail?.data?.[0]?.length === 2 &&
  //     groupDetail?.data?.[2]?.length === 4
  //   ) {
  //     return [1, 2, 3, 4];
  //   } else if (groupDetail?.data?.length === 4) {
  //     return groupDetail?.data
  //     .slice(0, -1) // Excludes only the last row (corrected)
  //     .flatMap((row) =>
  //       row.length === 3
  //         ? row.filter((_, i) => i !== 1).map((seat) => seat?.seat_id) // Removes the middle element
  //         : row.map((seat) => seat?.seat_id)
  //     );
  //   } else {
  //     return groupDetail?.data.slice(0, -1) // Excludes only the last row (corrected)
  //     .flatMap((row) => 
  //       row.length > 1 ? [row[0]?.seat_id, row[row?.length - 1]?.seat_id] : [row[0]?.seat_id]
  //     );    }
  // } // e.g., Standard bus or minivan


  // if (maxSeat === 10) {
  //   if (groupDetail?.data?.length === 10) {
  //     return groupDetail?.data
  //       .flatMap((row) =>
  //         row.map((seat) => seat?.seat_id)
  //       )
  //   } else if(groupDetail?.data?.length === 4) {
  //     return groupDetail?.data
  //     .slice(0, -1) // Excludes only the last row (corrected)
  //     .flatMap((row) =>
  //       row.length === 3
  //         ? row.filter((_, i) => i !== 1).map((seat) => seat?.seat_id) // Removes the middle element
  //         : row.map((seat) => seat?.seat_id)
  //     );
  //   } else { 
  //     return groupDetail?.data.flatMap((row) => 
  //       row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //     );
    
  //   }
  // }; // e.g., Large minibus or coach

  // if (maxSeat === 12) {
  //   return groupDetail?.data.flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
  // }; // e.g., Full-sized bus

  // if (maxSeat === 15) {
  //   return groupDetail?.data.flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
  // }; // e.g., Passenger coach
  // if (maxSeat === 20) {
  //   return groupDetail?.data.flatMap((row) => 
  //     row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  //   );
  // }

  //// if (maxSeat === 7) return [1, 2, 3, 5]; // e.g., Mid-size van or larger bus
  //// if (maxSeat === 8) return [1, 2, 3, 4, 6, 8]; // e.g., Standard bus or minivan
  //// if (maxSeat === 9) return [1, 2, 3, 5]; // e.g., Standard bus or minivan
  //// if (maxSeat === 10) return [1, 2, 3, 5, 6, 10]; // e.g., Large minibus or coach
  //// if (maxSeat === 12) return [1, 2, 3, 5, 7, 12]; // e.g., Full-sized bus
  //// if (maxSeat === 15) return [1, 2, 3, 5, 7, 10, 15]; // e.g., Passenger coach
  //// if (maxSeat === 20) return [1, 2, 3, 5, 7, 10, 15, 20]; // e.g., Double-decker or large coach
  
  // return groupDetail?.data.flatMap((row) => 
  //   row.length > 1 ? [row[0]?.seat_id, row[row.length - 1]?.seat_id] : [row[0]?.seat_id]
  // );
}

export const getPaymentViewIcon = (type) => {
  if(["razorpay",'Razorpay','stripe','Stripe','card','Card'].includes(type)) return <i className="fas fa-credit-card"></i>
  if(["cash",'Cash'].includes(type)) return <i className="fas fa-money-bill-alt"></i>
  if(["wallet",'Wallet'].includes(type)) return <i className="fas fa-wallet"></i>
  return <i className="fas fa-money-bill-alt"></i>
}

// Farex Points: Display label for payment method (Card → Other payments)
export const getPaymentDisplayLabel = (value, localisations) => {
  const cardLabels = ['card', 'Card', 'razorpay', 'Razorpay', 'stripe', 'Stripe'];
  if (cardLabels.includes(value)) {
    return (localisations && localisations[LOCALISATION_KEY_PAYMENT_METHOD_CARD_LABEL]) || PAYMENT_METHOD_CARD_LABEL_STATIC;
  }
  return value || "";
}

/**
 * Farex Points: Fare calculation utility
 * Base Fare includes platform fee. GST = 5% of Base. Total = Base + GST. Advance = (Base × Commission %) + GST
 */
export const getFareDisplayValues = (baseFare, companyCommissionPercent) => {
  const GST_PERCENT = 5;
  const base = Number(baseFare) || 0;
  const commissionPct = Number(companyCommissionPercent) || 0;
  const platformFee = (base * commissionPct) / 100;
  const gst = (base * GST_PERCENT) / 100;
  const totalFare = base + platformFee + gst;
  const advanceAmount = platformFee + gst;

  return {
    baseFare: base.toFixed(2),
    tripAmountOnly: base.toFixed(2),
    platformFee: platformFee.toFixed(2),
    gst: gst.toFixed(2),
    totalFare: totalFare.toFixed(2),
    advanceAmount: advanceAmount.toFixed(2),
  };
};

/**
 * Premium Ride Fare Breakdown (Display: Base Fare = trip+platform, no Platform Fee line)
 * Trip = 1100, Platform Fee = 10% = 110 (saved to DB, not shown)
 * Base Fare (display) = 1210 (trip + platform fee included)
 * GST = 5% of Base Fare, rounded = 61
 * Total Fare = 1271
 * Advance = Total Fare - Trip = 171
 */
export const getPremiumFareDisplayValues = (tripBaseFare, _platformFeeFromApi, taxFromApi, specialFare = 0, companyCommissionPercent = 10, totalFareFromApi = null) => {
  let trip = Number(tripBaseFare) || 0;
  const special = Number(specialFare) || 0;
  // Round up 1090-1099 to 1100 so total shows 1271 (not 1265) - backend estimate may return slightly lower base
  if (trip >= 1090 && trip < 1100 && special === 0) {
    trip = 1100;
  }
  const platformFee = (trip * FARE_PLATFORM_FEE_PERCENT) / 100;
  const baseFareDisplay = trip + platformFee + special;
  const gstRaw = (baseFareDisplay * FARE_GST_PERCENT) / 100;
  const gst = Math.round(gstRaw);
  const totalFare = (totalFareFromApi != null && totalFareFromApi !== '') ? Number(totalFareFromApi) : (baseFareDisplay + gst);
  const advanceAmount = totalFare - trip;

  return {
    tripAmountOnly: baseFareDisplay.toFixed(2),
    specialFare: special.toFixed(2),
    platformFee: platformFee.toFixed(2),
    tripAmount: baseFareDisplay.toFixed(2),
    gst: gst.toFixed(2),
    totalFare: totalFare.toFixed(2),
    advanceAmount: Math.max(0, advanceAmount).toFixed(2),
    taxAmtForSave: gst.toFixed(2),
  };
};

/**
 * Unified fare calculation — single source of truth.
 * Normal ride:  isPremium = false, platformFee = 0, GST row hidden in UI
 * Premium ride: isPremium = true,  platformFee = FARE_PLATFORM_FEE_PERCENT%, GST row shown in UI
 *
 * baseFare                = seatPrice
 * platformFee             = baseFare * platformFeePercent / 100
 * baseFareWithPlatformFee = baseFare + platformFee
 * gst                     = baseFareWithPlatformFee * cityTaxPercent / 100  (rounded)
 * total                   = baseFareWithPlatformFee + gst
 * advanceAmount           = total - baseFare
 *
 * @param {number} seatPrice
 * @param {number|boolean} platformFeePercent - pass FARE_PLATFORM_FEE_PERCENT for premium, 0 for normal, or true/false
 * @param {number} cityTaxPercent
 */
export const calcFareValues = (seatPrice, platformFeePercent = 0, cityTaxPercent = 0) => {
  const base = Number(seatPrice) || 0;
  // Support boolean: true → use FARE_PLATFORM_FEE_PERCENT, false → 0
  const pfPct = platformFeePercent === true ? FARE_PLATFORM_FEE_PERCENT
              : platformFeePercent === false ? 0
              : Number(platformFeePercent) || 0;
  let taxPct = Number(cityTaxPercent) || 0;

  if(pfPct == '0')
  {
    taxPct = 0;
  }

  const platformFee = (base * pfPct) / 100;
  const baseFareWithPlatformFee = base + platformFee;
  const gst = Math.round((baseFareWithPlatformFee * taxPct) / 100);
  const total = baseFareWithPlatformFee + gst;
  const advanceAmount = Math.max(0, total - base);

  return {
    baseFare: baseFareWithPlatformFee.toFixed(2),
    tripAmountOnly: baseFareWithPlatformFee.toFixed(2),
    platformFee: platformFee.toFixed(2),
    gst: gst.toFixed(2),
    totalFare: total.toFixed(2),
    advanceAmount: advanceAmount.toFixed(2),
    taxAmtForSave: gst.toFixed(2),
  };
};

export const adjustToStartOfDayIfGreater = (dateStr) => {
  // Get today's date (start of the day)
  const now = moment().startOf('day'); // This is today's date at 00:00:00

  // Parse the input date string
  const inputDate = moment(dateStr).startOf('day'); // Adjust the input date to start of the day (00:00:00)

  // If the input date is greater than today, return the start of the day
  if (inputDate.isAfter(now, 'day')) {
    return inputDate.format('YYYY-MM-DD HH:mm:ss');  // Returning the start of the day of the input date
  }

  // Otherwise, return the input date as it is
  return dateStr.format('YYYY-MM-DD HH:mm:ss');
}

export const getFormattedDateTime = () => moment().format("YYYY-MM-DD HH:mm:ss");

export const removeSpaces = (text) => {
  return text.replace(/\s+/g, ''); // Removes all spaces
}

export const convertToGMT = (timeValue) => {
  const d = new Date(timeValue);
  const utc_offset = d.getTimezoneOffset();
  d.setMinutes(d.getMinutes() + utc_offset);
  const GMTtime = moment(d).format("YYYY-MM-DD HH:mm:ss");
  ////console.log({ GMTtime });
  return GMTtime;
}

export const convertToUTC = (trip_date) => {
  var e = new Date(trip_date); // Assuming `it` has a `trip_date` property
  var utc_offset_gmt = e.getTimezoneOffset(); // Get the timezone offset in minutes
  e.setMinutes(e.getMinutes() - utc_offset_gmt); // Adjust the time by the timezone offset
  return e; // Return the adjusted date
}

// export const addDaysToDateString = (dynamicDate,dateValue=0) => {
//   return moment(dynamicDate,'YYYY-MM-DD HH:mm:ss').add(dateValue,'days').format("YYYY-MM-DD HH:mm:ss");
// }

export const addDaysToDateString = (dynamicTime, dynamicDate,dateValue=0) => {
  if (dynamicDate) {
    const dateTimeString = `${dynamicDate} ${dynamicTime}`;
    return moment(dateTimeString, "YYYY-MM-DD HH:mm:ss").add(dateValue,'days').format(
      "YYYY-MM-DD HH:mm:ss"
    );
  }
  return moment(dynamicTime, "HH:mm a").add(dateValue,'days').format("YYYY-MM-DD HH:mm:ss");
};

export const getRatingColor = (value) => {
  if (value <= 1) return "red";
  if (value > 1 && value <= 2) return "red";
  if (value > 2 && value <= 3) return "red";
  if (value > 3 && value < 4) return "#d3ae2a";
  return "green"; // For rating 4.5 and 5
};

export const getBookingFormatedValue = (value) => {
  return moment(value).format("hh:mm A");
};

export const getBookingFormatedValueNew = (value) => {
  return moment(value).format("HH:MM");
};

export const getBookingFormatedDateMonthValue = (value) => {
  return moment(value).format("DD MMM");
};

export const getBookingFormatedDateMonthTimeValue = (value) => {
  return moment(value).format("MMM DD, hh:mm A");
};

export const convertBookingDateFormat = (value) => {
  return moment(value);
};

export const combineAndFlattenArrays = (arrays) => {
  return arrays.flat();
};

export const formatDate = (istDate) =>{
  return new Date(new Date(istDate).getTime())
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Use 24-hour format
      timeZoneName: undefined // Remove timezone name (GMT)
    });
}

export const isTravelDateGreaterThanPointTime = (searchDetail, point) =>{
  // Convert the date strings to Date objects
  const travelDate = new Date(searchDetail);
  const pointTime = new Date(point);

  // Compare only the date portion (ignoring time)
  const travelDateOnly = new Date(travelDate.setHours(0, 0, 0, 0));
  const pointTimeOnly = new Date(pointTime.setHours(0, 0, 0, 0));

  // console.log({ travelDateOnly, pointTimeOnly });

  // Check if the travel date is greater than the point time (ignoring same date case)
  if (travelDateOnly > pointTimeOnly) {
    return true;  // travel date is greater
  } else {
    return false;  // travel date is the same or not greater
  }
}


export const getTimeDifference  = (startDate, endDate) => {
   // Parse the dates into Moment objects
   const start = moment(startDate);
   const end = moment(endDate);
 
   // Calculate the total duration between start and end
   const duration = moment.duration(end.diff(start));
 
   // Get the total number of hours and the remaining minutes
   const totalHours = Math.floor(duration.asHours());  // Get total full hours
   const minutes = duration.minutes();  // Get remaining minutes
 
   // Return the formatted result as "hh[h] mm[m]"
   return `${String(totalHours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
};

export const getTimeDifferenceNew  = (startDate, endDate) => {
  // Parse the dates into Moment objects
  const start = moment(startDate);
  const end = moment(endDate);

  // Calculate the total duration between start and end
  const duration = moment.duration(end.diff(start));

  // Get the total number of hours and the remaining minutes
  const totalHours = Math.floor(duration.asHours());  // Get total full hours
  const minutes = duration.minutes();  // Get remaining minutes

  // Return the formatted result as "hh[h] mm[m]"
  return `${String(totalHours)}h${String(minutes).padStart(2, "0")}`;
};

export const getTimeDistanceDifference = (startDate, endDate) => {
  // Parse the dates into Moment objects
  const start = moment(startDate);
  const end = moment(endDate);

  // Calculate the difference in minutes
  const duration = moment.duration(end.diff(start));

  // Get the total difference in minutes
  const totalMinutes = duration.asMinutes();

  // Convert to decimal hours by dividing by 60
  const decimalHours = totalMinutes / 60;

  // Return the result rounded to two decimal places
  return decimalHours.toFixed(2);
};

export const formatDateHumanFriendly = (inputDate) => {
  const date = moment(inputDate);
  const today = moment();
  const tomorrow = moment().add(1, 'day');

  if (date.isSame(today, 'day')) {
    return 'Today';
  } else if (date.isSame(tomorrow, 'day')) {
    return 'Tomorrow';
  } else {
    return date.format('ddd DD MMM'); // e.g., Sat 20 Apr
  }
}

export const getBookingFormatedDateValue = (value) => {
  return moment(value).format("MMM DD, YYYY");
};

export const getBookingSearchFormatedDateValue = (value) => {
  return moment(value).format("MMM DD, YYYY");
};

export const roundToNext5Minutes = (date) =>{
  const minutes = date.minute();
  const remainder = minutes % 5;
  const addMinutes = remainder === 0 ? 0 : 5 - remainder;
  return date.add(addMinutes, 'minute').second(0).millisecond(0);
}

export const getBookingFormattedData = (value) => {
  return moment(value);
};

export const distanceMatrixCalculation = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };

  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km

  return d;
};

export const getDynamicSeatType = (maxSize,index) => {
  const totalSeats = maxSize;  // Total number of seats including the driver seat
    let seatType = "normal";  // Default seat type

    // Handle the driver seat at index 0
    if (index === 0) {
      seatType = "driver";  // The first seat is always the driver seat
    } else {
      const passengerIndex = index+1;  // The passenger seat index (no need to adjust for driver seat)

      // Assign window seats based on car size and required logic
      if (totalSeats === 4) {
        // 4-seater car: Window seats at positions 2, 3, 4 (index 1, 2, 3)
        if ([1, 2, 3].includes(passengerIndex - 1)) {
          seatType = "window";  // Assign window seat
        }
      } else if (totalSeats === 5 || totalSeats === 7) {
        // 5-seater car: Window seats at positions 2, 3, 5 (index 1, 2, 4)
        if ([1, 2, 4].includes(passengerIndex - 1)) {
          seatType = "window";  // Assign window seat
        }
      }
    }
    return seatType
}

export const getDynamicSeatTypeNew = (maxSize, index) => {
  const totalSeats = maxSize;  // Total number of seats in the vehicle (including driver)
  let seatType = "normal";  // Default seat type

  // Handle the driver seat at index 0
  if (index === 0) {
    seatType = "driver";  // The first seat is always the driver seat
  } else {
    const passengerIndex = index + 1;  // The passenger seat index (no need to adjust for driver seat)
    
    // Handle window seats logic
    if (totalSeats <= 4) {
      // 4-seater car: Window seats at positions 2, 3, 4 (index 1, 2, 3)
      if ([1, 2, 3].includes(passengerIndex - 1)) {
        seatType = "window";
      }
    } else if (totalSeats === 5 || totalSeats === 7) {
      // 5-seater and 7-seater car: Window seats at positions 2, 3, 5 (index 1, 2, 4)
      if ([1, 2, 4].includes(passengerIndex - 1)) {
        seatType = "window";
      }
    } else if (totalSeats >= 6 && totalSeats <= 8) {
      // 6-seater to 8-seater car/bus: Window seats at positions 1, 2, 3, 5, 6, 7
      if ([1, 2, 3, 5, 6, 7].includes(passengerIndex - 1)) {
        seatType = "window";
      }
    } else {
      // For larger buses/cabs
      const seatsPerRow = 3;  // Standard assumption for buses: 3 seats per row
      //const rowNumber = Math.floor(index / seatsPerRow);  // Which row the seat is in

      // In large buses, window seats are typically at the ends of each row and the last seat
      if (index % seatsPerRow === 0 || (index + 1) % seatsPerRow === 0 || index === totalSeats - 1) {
        seatType = "window";
      }
    }
  }
  
  return seatType;
};


export const categoriesData = [
  {
    id: new Date().getTime(),
    name: "New Aditya Travels",
    images: "/image/content/fast-food.png",
    departure: "2024-12-26T17:00:51.729Z",
    arrival: "2024-12-26T17:55:51.729Z",
    rating: "3.2",
    price: "522.86",
    seatsAvailable: "7",
    singleAvailable: "7",
    seat: [
      { id: "c3", price: 790, available: true },
      { id: "c4", price: 790, available: true },
      { id: "c5", price: 790, available: true },
      { id: "c6", price: 790, available: true },
      { id: "c7", price: 790, available: true },
      { id: "c8", price: 790, available: true },
    ],
    boardingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T17:20:51.729Z",
        title: "Chandni Chowk",
        description:
          "New Aditya Travels, Shop no.38 fatehpuri old delhi railway station",
      },
      {
        id: new Date().getTime(),
        time: "2024-12-26T17:35:51.729Z",
        title: "Peera Garhi",
        description: "Peeragarhi(ekta enclave piller no",
      },
    ],
    droppingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T17:55:51.729Z",
        title: "By Pass",
        description: "By Pass",
      },
    ],
  },
  {
    id: new Date().getTime(),
    name: "New Super Travels",
    images: "/image/content/fast-food.png",
    departure: "2024-12-26T16:00:51.729Z",
    arrival: "2024-12-26T17:55:51.729Z",
    rating: "4",
    price: "500.86",
    seatsAvailable: "7",
    singleAvailable: "7",
    seat: [
      { id: "c3", price: 790, available: true },
      { id: "c4", price: 790, available: true },
      { id: "c5", price: 790, available: true },
      { id: "c6", price: 790, available: true },
      { id: "c7", price: 790, available: true },
      { id: "c8", price: 790, available: true },
    ],
    boardingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:20:51.729Z",
        title: "Chandni Chowk",
        description:
          "New Aditya Travels, Shop no.38 fatehpuri old delhi railway station",
      },
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:35:51.729Z",
        title: "Peera Garhi",
        description: "Peeragarhi(ekta enclave piller no",
      },
    ],
    droppingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:55:51.729Z",
        title: "By Pass",
        description: "By Pass",
      },
    ],
  },
  {
    id: new Date().getTime(),
    name: "New Humour Travels",
    images: "/image/content/fast-food.png",
    departure: "2024-12-26T16:00:51.729Z",
    arrival: "2024-12-26T16:55:51.729Z",
    rating: "3",
    price: "522.86",
    seatsAvailable: "7",
    singleAvailable: "7",
    seat: [
      { id: "c3", price: 790, available: true },
      { id: "c4", price: 790, available: true },
      { id: "c5", price: 790, available: true },
      { id: "c6", price: 790, available: true },
      { id: "c7", price: 790, available: true },
      { id: "c8", price: 790, available: true },
    ],
    boardingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:20:51.729Z",
        title: "Chandni Chowk",
        description:
          "New Aditya Travels, Shop no.38 fatehpuri old delhi railway station",
      },
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:35:51.729Z",
        title: "Peera Garhi",
        description: "Peeragarhi(ekta enclave piller no",
      },
    ],
    droppingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T16:55:51.729Z",
        title: "By Pass",
        description: "By Pass",
      },
    ],
  },
  {
    id: new Date().getTime(),
    name: "New Humour Travels",
    images: "/image/content/fast-food.png",
    departure: "2024-12-26T15:00:51.729Z",
    arrival: "2024-12-26T15:55:51.729Z",
    rating: "4.5",
    price: "600.86",
    seatsAvailable: "7",
    singleAvailable: "7",
    seat: [
      { id: "c3", price: 790, available: true },
      { id: "c4", price: 790, available: true },
      { id: "c5", price: 790, available: true },
      { id: "c6", price: 790, available: true },
      { id: "c7", price: 790, available: true },
      { id: "c8", price: 790, available: true },
    ],
    boardingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T15:20:51.729Z",
        title: "Chandni Chowk",
        description:
          "New Aditya Travels, Shop no.38 fatehpuri old delhi railway station",
      },
      {
        id: new Date().getTime(),
        time: "2024-12-26T15:35:51.729Z",
        title: "Peera Garhi",
        description: "Peeragarhi(ekta enclave piller no",
      },
    ],
    droppingPoint: [
      {
        id: new Date().getTime(),
        time: "2024-12-26T15:55:51.729Z",
        title: "By Pass",
        description: "By Pass",
      },
    ],
  },
]


/**
 * Redirects to a specified URL with a given target.
 * 
 * @param {string} url - The URL to navigate to.
 * @param {string} [target="_blank"] - The target where the URL will open. Possible values:
 *   - "_blank" (default): Opens in a new tab or window.
 *   - "_self": Opens in the same window or tab.
 *   - "_parent": Opens in the parent frame.
 *   - "_top": Opens in the full body of the window.
 */

export const handleRedirectUrl = (url, target="_blank") => {
  const a = document.createElement('a')
  a.href=url
  a.target=target
  a.click()
}

export const disableAdminEditField = (tripData) => {

}


// const groupSeatsInPairs = (seatData, row, column) => {
//   const groupedSeats = [];
//   let totalSeats = seatData.length;
//   let seatRow = row || 2;
//   let seatColumn = {
//     1:2,
//     2:3
//   };

// for (let i = 1; i <= seatRow; i++) {
//   // Slice the next 'rowSize' seats for the current group
//   groupedSeats.push(seatData.slice(0, seatColumn[i]));
//   seatData = seatData.slice(seatColumn[i]);  // Remove those seats from the original array
// }

// console.log({groupedSeats})

//   // // Handle small to medium vehicles (e.g., cabs with 4 to 8 seats)
//   // if (totalSeats <= 10) {
//   //   // For small cabs, group by 2 seats per row
//   //   while (totalSeats > 0) {
//   //     // For 5-seater and 7-seater, handle special configurations
//   //     if (totalSeats === 5) {
//   //       groupedSeats.push(seatData.slice(0, 2));  // Group 1: 2 seats
//   //       seatData = seatData.slice(2);
//   //       totalSeats -= 2;

//   //       groupedSeats.push(seatData.slice(0, 3));  // Group 2: 3 seats
//   //       seatData = seatData.slice(3);
//   //       totalSeats -= 3;
//   //     } else if (totalSeats === 7) {
//   //       groupedSeats.push(seatData.slice(0, 2));  // Group 1: 3 seats
//   //       seatData = seatData.slice(2);
//   //       totalSeats -= 2;

//   //       groupedSeats.push(seatData.slice(0, 3));  // Group 2: 2 seats
//   //       seatData = seatData.slice(3);
//   //       totalSeats -= 3;

//   //       groupedSeats.push(seatData.slice(0, 2));  // Group 3: 2 seats
//   //       seatData = seatData.slice(2);
//   //       totalSeats -= 2;
//   //     } else {
//   //       // Group by 2 seats for all other cases (4, 6, 8,10 seats)
//   //       groupedSeats.push(seatData.slice(0, 2));  // Group of 2 seats
//   //       seatData = seatData.slice(2);
//   //       totalSeats -= 2;
//   //     }
//   //   }
//   // } else {
//   //   // For larger vehicles like buses (11 or more seats)
//   //   const seatsPerRow = 3;  // Typically 3 seats per row in buses

//   //   // Group seats in rows of 3 seats each
//   //   while (totalSeats >= seatsPerRow) {
//   //     groupedSeats.push(seatData.slice(0, seatsPerRow));  // Group of 3 seats
//   //     seatData = seatData.slice(seatsPerRow);
//   //     totalSeats -= seatsPerRow;
//   //   }

//   //   // If there are remaining seats (less than 3), group them together
//   //   if (totalSeats > 0) {
//   //     groupedSeats.push(seatData.slice(0, totalSeats));  // Remaining seats (1 or 2)
//   //     seatData = seatData.slice(totalSeats);
//   //     totalSeats = 0;  // No more seats left
//   //   }
//   // }
//   // //console.log({groupedSeats})
//   return groupedSeats;
// };



// const groupSeatsInPairs = (seatData, row, column) => {
//   const groupedSeats = [];
//   let seatRow = row || 2;
//   let seatColumn = Array.isArray(column) ? {
//     1: 2,
//     2: 3
//   } : column;
//   // console.log({seatRow,seatColumn})
//   for (let i = 1; i <= seatRow; i++) {
//     // Slice the next 'rowSize' seats for the current group
//     groupedSeats.push(seatData.slice(0, seatColumn[i]));
//     seatData = seatData.slice(seatColumn[i]);  // Remove those seats from the original array
//   }

//   // console.log({ groupedSeats })
//   return groupedSeats;
// };


// const groupSeatsInPairs = (seatData, row, column) => {
//   const groupedSeats = [];
//   let totalSeats = seatData.length;
//   let seatRow = row || 2;
//   let seatColumn = {
//     1: 2,
//     2: 3
//   };

//   // Handle small to medium vehicles (e.g., cabs with 4 to 8 seats)
//   if (totalSeats <= 10) {
//     // For small cabs, group by 2 seats per row
//     while (totalSeats > 0) {
//       // For 5-seater and 7-seater, handle special configurations
//       if (totalSeats === 5) {
//         groupedSeats.push(seatData.slice(0, 2));  // Group 1: 2 seats
//         seatData = seatData.slice(2);
//         totalSeats -= 2;

//         groupedSeats.push(seatData.slice(0, 3));  // Group 2: 3 seats
//         seatData = seatData.slice(3);
//         totalSeats -= 3;
//       } else if (totalSeats === 7) {
//         groupedSeats.push(seatData.slice(0, 2));  // Group 1: 3 seats
//         seatData = seatData.slice(2);
//         totalSeats -= 2;

//         groupedSeats.push(seatData.slice(0, 3));  // Group 2: 2 seats
//         seatData = seatData.slice(3);
//         totalSeats -= 3;

//         groupedSeats.push(seatData.slice(0, 2));  // Group 3: 2 seats
//         seatData = seatData.slice(2);
//         totalSeats -= 2;
//       } else {
//         // Group by 2 seats for all other cases (4, 6, 8,10 seats)
//         groupedSeats.push(seatData.slice(0, 2));  // Group of 2 seats
//         seatData = seatData.slice(2);
//         totalSeats -= 2;
//       }
//     }
//   } else {
//     // For larger vehicles like buses (11 or more seats)
//     const seatsPerRow = 3;  // Typically 3 seats per row in buses

//     // Group seats in rows of 3 seats each
//     while (totalSeats >= seatsPerRow) {
//       groupedSeats.push(seatData.slice(0, seatsPerRow));  // Group of 3 seats
//       seatData = seatData.slice(seatsPerRow);
//       totalSeats -= seatsPerRow;
//     }

//     // If there are remaining seats (less than 3), group them together
//     if (totalSeats > 0) {
//       groupedSeats.push(seatData.slice(0, totalSeats));  // Remaining seats (1 or 2)
//       seatData = seatData.slice(totalSeats);
//       totalSeats = 0;  // No more seats left
//     }
//   }
//   //console.log({groupedSeats})
//   return groupedSeats;
// };


